<template>
  <div id="bannerCarouselCustom" v-if="existBanner">
    <div
      id="carouselCustom"
      v-if="typeBanner === 1"
      class="carousel-custom columns mx-0 is-mobile"
    >
      <div
        v-for="(img, index) in itemCarousel.listUrlBanner"
        :key="'imgCarousel' + index"
        class="p-0 img-carousel column is-12"
        :style="{ 'background-image': `url(${img})` }"
      ></div>
      <div class="content-actions-carousel">
        <i
          @click="beforeImgCarousel()"
          class="icon-arrow-carousel left"
          :style="{ background: itemCarousel.desingsCarousel.colorArrows }"
        ></i>
        <span
          class="font-letter-carousel"
          :style="{ color: itemCarousel.desingsCarousel.colorLetter }"
          >{{
            positonItemCarousel + " de " + itemCarousel.listUrlBanner.length
          }}</span
        >
        <i
          @click="afterIgmCarousel()"
          class="icon-arrow-carousel right"
          :style="{ background: itemCarousel.desingsCarousel.colorArrows }"
        ></i>
      </div>
    </div>
    <div class="banner-content" v-else>
      <div
        :style="{ 'background-image': `url(${itemCarousel.listUrlBanner[0]})` }"
        class="banner-img"
        v-if="itemCarousel.listUrlBanner.length > 0"
      ></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import whiteLabelTypes from '@/store/types/whiteLabel';

export default {
  props: ['activeView'],
  data () {
    return {
      changeItem: false,
      typeBanner: 0,
      intervalVarible: null,
      positonItemCarousel: 1,
      itemCarousel: {
        typeBanner: 0,
        listUrlBanner: [],
        desingsCarousel: {
          colorArrows: null,
          colorLetter: null
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      listBanner: [whiteLabelTypes.getters.getListBannersMenu],
      bannerMenuId: [whiteLabelTypes.getters.getMenuIdBanner],
      existBanner: [whiteLabelTypes.getters.getExistBanner]
    })
  },
  watch: {
    bannerMenuId () {
      this.$store.commit('whiteLabel:setExistBanner', false);
      this.changeBanner();
    },
    listBanner () {
      this.changeBanner();
    },
    typeBanner () {
      if (this.typeBanner === 1) {
        this.changeCarousel();
      } else {
        clearInterval(this.intervalVarible);
      }
    }
  },
  methods: {
    changeBanner () {
      if (this.listBanner.length > 0) {
        this.listBanner.forEach((element) => {
          Object.keys(this.itemCarousel).forEach((item) => {
            if (element.menuId === this.bannerMenuId) {
              this.$store.commit('whiteLabel:setExistBanner', true);
              this.typeBanner = element.typeBanner;
              this.itemCarousel[item] = element[item];
            }
          });
        });
      }
    },
    changeCarousel () {
      this.intervalVarible = setInterval(() => {
        const carousel = document.getElementById('carouselCustom');
        if (
          carousel.scrollLeft + carousel.offsetWidth ===
          carousel.scrollWidth
        ) {
          this.positonItemCarousel = 1;
        } else {
          this.positonItemCarousel += 1;
        }
        console.log(carousel.offsetWidth, carousel.scrollWidth);
      }, 4000);
    },
    afterIgmCarousel () {
      const contentCarousel = document.getElementById('bannerCarouselCustom');
      const carousel = document.getElementById('carouselCustom');
      let countLefScroll = contentCarousel.offsetWidth;
      if (carousel.scrollLeft + carousel.offsetWidth === carousel.scrollWidth) {
        countLefScroll = -(carousel.scrollLeft + carousel.offsetWidth);
        this.positonItemCarousel = 1;
      } else {
        this.positonItemCarousel += 1;
      }
      carousel.scrollBy({ left: countLefScroll, behavior: 'smooth' });
    },
    beforeImgCarousel () {
      const carousel = document.getElementById('carouselCustom');
      let before = -carousel.offsetWidth;
      if (this.positonItemCarousel - 1 === 0) {
        this.positonItemCarousel = this.itemCarousel.listUrlBanner.length;
        before = carousel.scrollWidth;
      } else {
        this.positonItemCarousel = this.positonItemCarousel - 1;
      }
      carousel.scrollBy({ left: before, behavior: 'smooth' });
    }
  }
};
</script>
<style lang="scss">
#bannerCarouselCustom {
  width: 100%;
  align-self: flex-start;
  .carousel-custom {
    width: 100%;
    height: 150px;
    background-color: #fff;
    display: flex;
    overflow-x: hidden;
    .img-carousel {
      height: 150px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    .content-actions-carousel {
      position: absolute;
      right: 12px;
      display: flex;
      align-items: center;
      top: 113px;
      margin-bottom: 18px;
      .font-letter-carousel {
        font-size: 14px;
        font-weight: 600;
        line-height: 19.07px;
      }
      .icon-arrow-carousel {
        width: 12px;
        height: 12px;
        display: flex;
        mask-repeat: no-repeat;
        mask-position: center;
        align-items: center;
        justify-content: center;
        mask-size: contain;
        cursor: pointer;
        &.left {
          margin-right: 10px;
          -webkit-mask-image: url("~@/assets/images/icons/icon-arrow-left-carousel.svg");
          mask-image: url("~@/assets/images/icons/icon-arrow-left-carousel.svg");
        }
        &.right {
          margin-left: 10px;
          -webkit-mask-image: url("~@/assets/images/icons/icon-arrow-right-carousel.svg");
          mask-image: url("~@/assets/images/icons/icon-arrow-right-carousel.svg");
        }
      }
    }
  }
  .banner-content {
    width: 100%;
    height: 150px;
    background-color: #fff;
    .banner-img {
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
      background-position: center;
      height: 150px;
    }
  }
}
</style>
